import { computed, makeObservable, observable, runInAction } from "mobx";
import { RootStore } from "./RootStore";
import { FieldGroupId } from "../lib/enums";
import { EQ5D5L } from "../models/EQ5D5L";
import { convertFormsToEQ5D5Ls } from "../utils/formHelpers";
import { FormGetResponse } from "../models/Form";

class EQ5D5LStore {
  rootStore: RootStore;
  eQ5D5Ls: EQ5D5L[] | undefined = undefined;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      currentScore: computed,
      eQ5D5Ls: observable
    });
  }

  get currentScore() {
    if(!this.eQ5D5Ls || this.eQ5D5Ls.length === 0) {
      return null;
    }
    let latestDate = "";
    let latestValue = ""
    this.eQ5D5Ls.forEach(eq => {
      if(eq.datum > latestDate) {
        latestDate = eq.datum;
        latestValue = eq.vas;
      }
    })
    return latestValue;
  }

  setEQ5D5Ls(data: EQ5D5L[] | undefined) {
    runInAction(() => {
      this.eQ5D5Ls = data ?? [];
    });
  }

  get5Q5DLs = async () => {
    const forms = await this.rootStore.formStore.getFormsByFormId(FieldGroupId.EQ5D5L_FIELD_GROUP_ID);
    this.setEQ5D5Ls(convertFormsToEQ5D5Ls(forms as FormGetResponse[]));
  }

}

export default EQ5D5LStore;
